import { truncateText } from 'app/utils/text'
import styles from './styles.module.scss'
import clsx from 'clsx'

// This component returns a clamped text if clamp feature is supported by CSS and truncates it if clmap rule is not supported
function ClamedText({ linesNum, maxChar, text, className }) {
  // it is prefered to handle limiting by line number by CSS instead of truncating so first check if browser supports otherwise use JS
  const cssLineClampSupported = CSS.supports('line-clamp', linesNum) || CSS.supports('-webkit-line-clamp', linesNum)

  const textToRender = cssLineClampSupported ? text : truncateText(text, maxChar)

  const cusotmStyles = {
    WebkitLineClamp: linesNum,
    lineClamp: linesNum,
  }

  return (
    <span style={cusotmStyles} className={clsx(styles.clamped_text, className)}>
      {textToRender}
    </span>
  )
}

export default ClamedText
